var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[_c('navigation',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n            HLT Suivi Patient\n        ")]},proxy:true}])}),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }